import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { TiInfoOutline, TiTick } from "react-icons/ti";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { axios } from "../../../../Global";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import { useNavigate } from "react-router-dom";

export default function ProceedToProject({
  showPromptElement,
  setShowPromptElement,
  contractId,
}) {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    const Body = {
      name: e.target.project_name.value,
    };

    axios
      .post(`/dashboard/contract-to-project-conversion/${contractId}`, Body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          setShowPromptElement((p) => ({ ...p, open: false }));
          dispatch(
            setAppError({
              msg: res?.data?.message || `Added successfully`,
              color: "success",
            })
          );
          navigate(`/dashboard/project/${res?.data?.data?.id}`);
        }
      })
      .catch((error) =>
        dispatch(
          setAppError({
            msg: error.message,
          })
        )
      )
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        showPromptElement.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
        <div className="flex justify-between items-center w-full">
          <h1 className="text-xl font-semibold">Proceed to Project</h1>
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              setShowPromptElement((p) => ({ ...p, open: false }));
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        <h2 className="text-sm">Create a new project for your contract.</h2>
        <form onSubmit={onSubmitHandler}>
          <div className="w-full flex flex-col gap-3 my-3 p-5">
            <div className="flex flex-col w-full gap-1">
              <label htmlFor="" className="px-1">
                Project Name
              </label>
              <input
                type="text"
                name="project_name"
                className="input input-bordered "
                placeholder="Enter project name"
                required
              />
            </div>
          </div>
          <div className="flex gap-3 w-full justify-center">
            <button
              className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red"
              type="submit"
            >
              {loading ? (
                <CgSpinner className="animate-spin mx-auto" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
